import React, { useEffect, useState, useContext } from "react";
import PropTypes from "prop-types";
import AppContext from "context/Context";
import Flex from "components/common/Flex";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dropdown, Col, Modal, Row, Button, Image, OverlayTrigger, Tooltip } from "react-bootstrap";
import IconButton from "components/common/IconButton";
import * as Constants from "common/constants";
import * as General from "common/general";
import * as em from "common/ErrorMessages";
import { EncryptStorage } from "encrypt-storage";
import { toast } from "react-toastify";

import { useTranslation } from "react-i18next";
import LoaderIcon from "../Preloader";

const AddTruck = ({ successCallBackFunction, allTrucks, hideAddTruck, RelatedCompany, showComponent }) => {
	const [errorContainerVisiblity, showErrorContainer] = useState(false);
	const [errorMessage, setErrorMessage] = useState("");
	const [plateNumber, setPlateNumber] = useState("");
	const [type, setType] = useState("");
	const [subType, setSubType] = useState("");
	const [plateNumberError, setPlateNumberError] = useState("");
	const [vehicleTypeError, setVehicleTypeError] = useState("");
	const [vehicleSerialNumber, setVehicleSerialNumber] = useState("");
	const [serialNumberError, setSerialNumberError] = useState("");
	const [tareWeightError, setTareWeightError] = useState("");
	const [size, setSize] = useState("");
	const [sizeError, setSizeError] = useState("");
	const [tareWeight, setTareWeight] = useState("");
	const [capacity, setCapacity] = useState("0");
	const [capacityUnit, setCapacityUnit] = useState("Kgs");
	const [transporterCompanyId, setTransporterCompanyId] = useState("truck");
	const [capacityError, setCapacityError] = useState("");
	const [t, i18n] = useTranslation();
	const [isFinish, setIsFinish] = useState(false);
	const timeOut = 5000;
	const encryptStorage1 = new EncryptStorage("secret-key-value", {
		prefix: "@mwan",
	});
	const plateNumberRegex = /^[A-Za-z]{3} [0-9]{4}$/;
	const vehicleSerialRegex = /^[0-9]{8,}$/;

	const vehicleData = {
		"Compactor Truck": ["Rear Loader Compactor", "Side Loader Compactor", "Front Loader Compactor"],
		"Loader Truck": ["Hook Lift Loader", "Skip Loader"],
		Tankers: ["Liquid Waste Tanker", "Vacuum Tanker", "Trella Tanker"],
		"Tipper Truck": ["Tipper", "Mini Tipper", "Crane Tipper", "Tipper Trella"],
		"Waste Compactor": ["Static Compactor", "Trella Compactor"],
		"Enclosed Truck": ["Enclosed Refrigerated Truck", "Enclosed Medical Waste Truck", "Enclosed Trella", "Enclosed Van"],
		"Pickup Truck": ["Pickup", "Refrigerated Pickup", "Mini Pickup"],
		"Miscellaneous Truck": ["Curtain Truck", "Flatbed Truck", "Carbon Ash Truck"],
	};
	useEffect(() => {}, []);

	/*************** LOAD COMPANIES START ************************/
	const bindCompanies = (compTypeID) => {
		const GetAllCompaniesSuccess = (responseObject) => {
			console.log(responseObject);
		};
		const GetAllCompanyCompaniesFailure = (error) => {
			setTimeout(() => {}, 1000);
		};
		console.log(compTypeID);
		var endPoint = Constants.GetCompaniesByType + compTypeID;
		General.GetFromEndPoint(endPoint, null, null, GetAllCompaniesSuccess, GetAllCompanyCompaniesFailure);
	};

	/*************** LOAD COMPANIES END ************************/

	const handleDropDownChange = () => {};

	const handleCancelNew = () => {
		hideAddTruck();
	};
	const checkCapacity = (value) => {
		var capacity = document.getElementById("capacity");
		if (value >= 0) {
			setCapacity(value);
			setCapacityError("");
		} else {
			setCapacityError(t("Capacity must be a positive number."));
		}
	};

	const handleAddTruck = async () => {
		setIsFinish(true);

		//get all elements
		var fieldplateNumber = document.getElementById("plateNumber");
		var fieldtype = document.getElementById("wastetypeTypeSelect");
		var fieldsubType = document.getElementById("subType");
		var fieldsize = document.getElementById("size");
		var errorContainerDate = document.getElementById("errorContainerDate");
		var AddTruckJSON = {
			plateNumber: plateNumber,
			type: type,
			subType: subType,
			size: size,
			tareWeight: tareWeight,
			capacity: capacity,
			capacityUnit: capacityUnit,
			vehicleSerialNumber: vehicleSerialNumber,
		};
		var isValidForm = true;
		//check if fields are filled and set the invalid class in case they are not
		if (!plateNumberRegex.test(plateNumber)) {
			setErrorMessage(t("Plate Number must be in the format ABC1234 (3 letters followed by 4 numbers)."));
			setPlateNumberError(t("Plate Number must be in the format ABC1234 (3 letters followed by 4 numbers)."));
			showErrorContainer(true);
			setIsFinish(false);
			var isValidForm = false;
		} else {
			setPlateNumberError(t(""));
		}
		if (!type) {
			setErrorMessage(t("Truck Type Required."));
			setVehicleTypeError(t("Truck Type Required."));
			showErrorContainer(true);
			setIsFinish(false);
			var isValidForm = false;
		} else {
			setVehicleTypeError(t(""));
		}
		if (!vehicleSerialNumber) {
			setErrorMessage(t("Vehicle Serial Number Required."));
			setSerialNumberError(t("Vehicle Serial Number Required."));
			showErrorContainer(true);
			setIsFinish(false);
			var isValidForm = false;
		} else if (!/^[0-9]{8,}$/.test(vehicleSerialNumber)) {
			setSerialNumberError(t("Vehicle Serial Number must contain only English digits and be at least 8 characters long."));
			isValidForm = false;
		} else {
			setSerialNumberError("");
		}
		if (size && size < 500) {
			console.log(size);
			setSizeError(t("Gross Weight must be a valid number and must be 500 or more"));
			console.log({ sizeError });

			showErrorContainer(true);
			setIsFinish(false);
			var isValidForm = false;
		} else {
			setSizeError(t(""));
		}

		if (!tareWeight) {
			setErrorMessage(t("Tare Weight must be a valid number and must be 500 or more"));
			setTareWeightError(t("Tare Weight must be a valid number and must be 500 or more"));
			showErrorContainer(true);
			setIsFinish(false);
			var isValidForm = false;
		} else {
			setTareWeightError(t(""));
		}
		if (isNaN(tareWeight) || tareWeight < 500) {
			setErrorMessage(t("Tare Weight must be a valid number and must be 500 or more"));
			setTareWeightError(t("Tare Weight must be a valid number and must be 500 or more"));
			showErrorContainer(true);
			setIsFinish(false);
			var isValidForm = false;
		}
		const plateExists = allTrucks.some((truck) => truck.plateNumber === plateNumber);
		if (plateExists) {
			setPlateNumberError(t("The plate number already exists."));
			showErrorContainer(true);
			setIsFinish(false);
			var isValidForm = false;
		}
		if (isValidForm == false) {
			return;
		} else {
			const AddTruckSuccess = (responseObject) => {
				toast.success("Success");
				handleCancelNew();
				successCallBackFunction(true);
				setIsFinish(false);
			};

			const AddTruckFailure = (error) => {
				setTimeout(() => {
					setIsFinish(false);
				}, timeOut);

				toast.error("An error occured, please try again later.", {
					autoClose: timeOut,
				});
			};

			var AddTruckJSONString = JSON.stringify(AddTruckJSON);
			var AddCompanyEndPoint = Constants.AddTransporterTruckData + RelatedCompany;
			General.PostToEndPoint(AddCompanyEndPoint, null, AddTruckJSONString, AddTruckSuccess, AddTruckFailure);
		}
	};
	const {
		config: { isRTL },
	} = useContext(AppContext);

	const handleTypeChange = (event) => {
		setType(event.target.value);
		if (event.target.value != "") {
			setVehicleTypeError("");
		}
		setSubType(""); // Reset subType when type changes
	};
	const handlePlateNumberChange = (value) => {
		// Convert input to uppercase for consistency
		let formattedValue = value.toUpperCase();

		// Enforce letters for the first three characters
		let lettersPart = formattedValue.slice(0, 3).replace(/[^A-Z]/g, ""); // Only letters in first three positions

		// Enforce digits for the remaining four characters
		let numbersPart = formattedValue.slice(3).replace(/[^0-9]/g, ""); // Only numbers in last four positions

		// Combine the two parts and limit the length to 7
		formattedValue = `${lettersPart}${numbersPart ? " " + numbersPart : ""}`.trim();
		if (formattedValue.length > 8) {
			formattedValue = formattedValue.slice(0, 8);
		}

		setPlateNumber(formattedValue);

		// Validate the final value
		const plateNumberRegex = /^[A-Z]{3} \d{4}$/; // Strict format: 3 uppercase letters followed by 4 digits
		if (!plateNumberRegex.test(formattedValue)) {
			setPlateNumberError(t("Plate Number must be in the format ABC1234 (3 uppercase letters followed by 4 digits)."));
		} else {
			setPlateNumberError(""); // Clear error if valid
		}
	};

	return (
		<Modal show={showComponent} onHide={handleCancelNew} size="lg">
			<Modal.Header closeButton className="border-200">
				<Modal.Title as="h5">
					<Flex alignItems="center">
						<div className="icon-item bg-soft-success shadow-none">
							<FontAwesomeIcon icon="fa-solid fa-truck" />
						</div>
						<div className="ms-2">{t(`New Vehicle`)}</div>
					</Flex>
				</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<Row className="g-0 align-items-center">
					<Col>
						<div className="mb-3">
							<label className="form-label">
								{t(`Plate Number`)}
								<span style={{ color: "red" }}>*</span>
							</label>
							<input
								type="text"
								id="plateNumber"
								className={`form-control ${plateNumberError ? "is-invalid" : ""}`}
								value={plateNumber}
								onChange={(event) => handlePlateNumberChange(event.target.value)}
							/>
							{plateNumberError && <div className="invalid-feedback">{plateNumberError}</div>}
						</div>
						<div className="mb-3">
							<label className="form-label">
								{t(`Vehicle Serial Number`)}
								<span style={{ color: "red" }}>*</span>
							</label>
							<input
								type="text"
								id="plateNumber"
								className={`form-control ${serialNumberError ? "is-invalid" : ""}`}
								value={vehicleSerialNumber}
								onChange={(event) => {
									const value = event.target.value.replace(/[^0-9]/g, "");
									setVehicleSerialNumber(value);
									if (/^[0-9]{8,}$/.test(value)) {
										setSerialNumberError("");
									} else {
										setSerialNumberError(t("Vehicle Serial Number must contain only English digits and be at least 8 characters long."));
									}
								}}
							/>
							{serialNumberError && <div className="invalid-feedback">{serialNumberError}</div>}
						</div>
						<div className="mb-3">
							<label className="form-label">
								{t(`Vehicle Type`)}
								<span style={{ color: "red" }}>*</span>
							</label>
							<select id="type" className={`form-control ${vehicleTypeError ? "is-invalid" : ""}`} value={type} onChange={handleTypeChange}>
								<option value="">{t("Select Vehicle Type")}</option>
								{Object.keys(vehicleData).map((vehicleType) => (
									<option key={vehicleType} value={vehicleType}>
										{t(vehicleType)}
									</option>
								))}
							</select>
							{vehicleTypeError && <div className="invalid-feedback">{vehicleTypeError}</div>}
						</div>
						<div className="mb-3">
							<label className="form-label">{t(`Vehicle Subtype`)}</label>
							<select
								id="subType"
								className="form-control"
								value={subType}
								onChange={(event) => setSubType(event.target.value)}
								disabled={!type} // Disable if no type is selected
							>
								<option value="">{t("Select Vehicle Subtype")}</option>
								{type &&
									vehicleData[type].map((subTypeOption) => (
										<option key={subTypeOption} value={subTypeOption}>
											{t(subTypeOption)}
										</option>
									))}
							</select>
						</div>
						<div className="mb-3">
							<label className="form-label">{t(`Vehicle Gross Weight`)}</label>
							<input
								type="number"
								id="size"
								className={`form-control ${sizeError ? "is-invalid" : ""}`}
								value={size}
								onChange={(event) => {
									const inputValue = event.target.value;
									setSize(event.target.value);
									if (!inputValue) {
										setSizeError(t("Gross Weight must be a valid number and must be 500 or more"));
									} else if (parseFloat(inputValue) < 500) {
										setSizeError(t("Gross Weight must be a valid number and must be 500 or more"));
									} else {
										setSizeError(""); // Clear the error if valid
									}
								}}
							/>
							{sizeError && <div className="invalid-feedback">{sizeError}</div>}
						</div>
						<div className="mb-3">
							<label className="form-label">
								{t(`Vehicle Tare Weight`)}
								<span style={{ color: "red" }}>*</span>
							</label>
							<input
								type="number"
								id="tareWeight"
								className={`form-control ${tareWeightError ? "is-invalid" : ""}`}
								value={tareWeight}
								onChange={(event) => {
									setTareWeight(event.target.value);
									setTareWeightError("");
								}}
							/>
							{tareWeightError && <div className="invalid-feedback">{tareWeightError}</div>}
						</div>
						<div className="mb-3">
							<label className="form-label">{t(`Vehicle Load Capacity`)}</label>
							<input
								type="number"
								id="capacity"
								className={`form-control ${capacityError ? "is-invalid" : ""}`}
								value={capacity}
								min={0}
								onChange={(event) => {
									checkCapacity(event.target.value);
								}}
							/>
							{capacityError && <div className="invalid-feedback">{capacityError}</div>}
						</div>
						<div className="mb-3">
							<label className="form-label">{t(`Vehicle Load Capacity UOM`)}</label>
							<select id="capacityUnit" className={`form-select`} value={capacityUnit} onChange={(e) => setCapacityUnit(e.target.value)}>
								{/* <option value="">{t("Capacity Unit")}</option> */}
								<option key={0} value="Kgs">
									{t("Kgs")}
								</option>
								<option key={1} value="Ltrs">
									{t("Ltrs")}
								</option>
								<option key={2} value="Tons">
									{t("Tons")}
								</option>
							</select>
						</div>
					</Col>
				</Row>
			</Modal.Body>
			<Modal.Footer className="border-200">
				{isFinish && <LoaderIcon />}
				<div>
					<Button size="sm" onClick={handleCancelNew} variant="secondary">
						{t("Cancel")}
					</Button>
					<IconButton size="sm" icon="check" className="ms-2" variant="primary" onClick={handleAddTruck}>
						{t("Confirm")}
					</IconButton>
				</div>

				{/* {errorContainerVisiblity && (
					<div id="errorContainer" className="loginAlert popupAlert">
						{errorMessage}
					</div>
				)} */}
			</Modal.Footer>
		</Modal>
	);
};

AddTruck.propTypes = {
	showComponent: PropTypes.bool,
};

export default AddTruck;
